const formatKeys = {
    number: 'number',
    percent: 'percent',
    currency: 'currency',
    date: 'date',
    quarter: 'quarter',
    boolean: 'boolean',
    array: 'array',
    string: 'string',
    ids: 'ids'
};

const metrics = {
    GroupBy: {
        titleKey: 'day',
        isSortable: true,
        Hour: {
            format: formatKeys.date,
            dateType: 'dateTime',
            title: 'Hour'
        },
        Day: {
            format: formatKeys.date,
            title: 'Day'
        },
        Week: {
            format: formatKeys.date,
            dateType: 'dateWeek',
            title: 'Week'
        },
        Month: {
            format: formatKeys.date,
            dateType: 'dateMonth',
            title: 'Month'
        },
        Quarter: {
            format: 'quarter',
            title: 'Quarter'
        },
        Year: {
            format: formatKeys.date,
            dateType: 'dateYear',
            title: 'Year'
        },
        WeekDay: {
            format: formatKeys.date,
            dateType: 'dateWeekDay',
            title: 'WeekDay'
        },
        DayHour: {
            format: '',
            title: 'DayHour'
        },
        Offer: {
            format: formatKeys.ids,
            title: 'Offer'
        },
        Goal: {
            format: formatKeys.ids,
            title: 'Goal'
        },
        GoalEntry: {
            format: '',
            title: 'GoalEntry'
        },
        GoalAction: {
            format: '',
            title: ''
        },
        Link: {
            format: formatKeys.ids,
            title: 'Link'
        },
        Publisher: {
            format: formatKeys.ids,
            title: 'Publisher'
        },
        UtmMedium: {
            format: '',
            title: 'UtmMedium'
        },
        UtmSource: {
            format: '',
            title: 'UtmSource'
        },
        UtmCampaign: {
            format: '',
            title: 'UtmCampaign'
        },
        UtmTerm: {
            format: '',
            title: 'UtmTerm'
        },
        UtmContent: {
            format: '',
            title: 'UtmContent'
        },
        Param1: {
            format: '',
            title: 'Param1'
        },
        Param2: {
            format: '',
            title: 'Param2'
        },
        Param3: {
            format: '',
            title: 'Param3'
        },
        Param4: {
            format: '',
            title: 'Param4'
        },
        Param5: {
            format: '',
            title: 'Param5'
        },
        Param6: {
            format: '',
            title: 'Param6'
        },
        Param7: {
            format: '',
            title: 'Param7'
        },
        Param8: {
            format: '',
            title: 'Param8'
        },
        Param9: {
            format: '',
            title: 'Param9'
        },
        Country: {
            format: formatKeys.ids,
            title: 'Country'
        },
        District: {
            format: formatKeys.ids,
            title: 'District'
        },
        Area: {
            format: formatKeys.ids,
            title: 'Area'
        },
        City: {
            format: formatKeys.ids,
            title: 'City'
        },
        Rejected: {
            format: formatKeys.boolean,
            title: 'Rejected',
            values: [
                {value: '0', title: 'No'},
                {value: '1', title: 'Yes'}
            ]
        },
        DeviceType: {
            format: '',
            title: 'DeviceType',
            values: [
                {value: 'mobile', title: 'mobile'},
                {value: 'tablet', title: 'tablet'},
                {value: 'desktop', title: 'desktop'}
            ]
        },
        DeviceOs: {
            format: '',
            title: 'DeviceOs',
            values: [
                {value: 'android', title: 'android'},
                {value: 'ios', title: 'ios'},
                {value: 'windows', title: 'windows'}
            ]
        },
        RefererDomain: {
            format: '',
            title: 'RefererDomain'
        },
        RefererSignificantSubdomain: {
            format: '',
            title: 'RefererSignificantSubdomain'
        },
        RefererPath: {
            format: '',
            title: 'RefererPath'
        },
        RefererPage: {
            format: '',
            title: 'RefererPage'
        },
        CreativeType: {
            format: formatKeys.ids,
            title: 'CreativeType'
        },
        CreativeId: {
            format: formatKeys.ids,
            title: 'CreativeId'
        },
        CreativeLinkId: {
            format: formatKeys.ids,
            title: 'CreativeLinkId'
        },
        CreativeContainerId: {
            format: formatKeys.ids,
            title: 'CreativeContainerId'
        },
        CreativeBannerId: {
            format: formatKeys.ids,
            title: 'CreativeBannerId'
        },
        CreativeLandingId: {
            format: formatKeys.ids,
            title: 'CreativeLandingId'
        },
        CreativePromoCodeId: {
            format: formatKeys.ids,
            title: 'CreativePromoCodeId'
        }
    },
    Visits: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    Visitors: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    VisitorsPerSaleCountNew: {
        format: formatKeys.number,
        titleKey: 'open',
        visible: false
    },
    VisitorsPerSaleCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled',
        visible: false
    },
    VisitorsPerSaleCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'approved',
        visible: false
    },
    ActionNameVerifiedCountNew: {
        format: formatKeys.number,
        titleKey: 'open'
    },
    ActionNameVerifiedCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled'
    },
    ActionNameVerifiedCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'verified',
        visible: true,
        isSortable: true
    },
    ActionNameRegCountNew: {
        format: formatKeys.number,
        titleKey: 'open'
    },
    ActionNameRegCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled'
    },
    ActionNameRegCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'regs',
        visible: true,
        isSortable: true
    },
    ActionTypeSaleCountNew: {
        format: formatKeys.number,
        titleKey: 'open',
        visible: false
    },
    ActionTypeSaleCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled'
    },
    ActionTypeSaleCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'sales',
        visible: false,
        isSortable: true
    },
    ConversionRatioToRegNew: {
        format: formatKeys.percent,
        titleKey: 'open'
    },
    ConversionRatioToRegRejected: {
        format: formatKeys.percent,
        titleKey: 'cancelled'
    },
    ConversionRatioToRegConfirmed: {
        format: formatKeys.percent,
        titleKey: 'reg',
        visible: true,
        isSortable: true
    },
    PublisherEarnPerClickAmountNew: {
        format: formatKeys.currency,
        titleKey: 'open',
        isSortable: true
    },
    PublisherEarnPerClickAmountRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
        isSortable: true
    },
    PublisherEarnPerClickAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'epc',
        visible: true,
        isSortable: true
    },
    SaleSumNew: {
        format: formatKeys.currency,
        titleKey: 'open',
        isSortable: true
    },
    SaleSumRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
        isSortable: true
    },
    SaleSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'saleComm',
        visible: false
    },
    FirstPaymentCountNew: {
        format: formatKeys.number,
        titleKey: 'open',
    },
    FirstPaymentCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled',
    },
    FirstPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'FTDsCount',
        visible: true,
        isSortable: true
    },
    TotalPaymentCountNew: {
        format: formatKeys.number,
        titleKey: 'open',
    },
    TotalPaymentCountRejected: {
        format: formatKeys.number,
        titleKey: 'cancelled',
    },
    TotalPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'totalCount',
        visible: true,
        isSortable: true
    },
    FirstPaymentSumNew: {
        format: formatKeys.currency,
        titleKey: 'open',
    },
    FirstPaymentSumRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
    },
    FirstPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'FTDsSum',
        visible: true,
        isSortable: true
    },
    TotalPaymentSumNew: {
        format: formatKeys.currency,
        titleKey: 'open',
    },
    TotalPaymentSumRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
    },
    TotalPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'totalSum',
        visible: true,
        isSortable: true
    },
    PromotionTotalAmountNew: {
        format: formatKeys.currency,
        titleKey: 'open'
    },
    PromotionTotalAmountRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled'
    },
    PromotionTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'approved',
        visible: false
    },
    PublisherCommissionTotalAmountNew: {
        format: formatKeys.currency,
        titleKey: 'open'
    },
    PublisherCommissionTotalAmountRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled'
    },
    PublisherCreditTotalAmountNew: {
        format: formatKeys.currency,
        titleKey: 'open'
    },
    PublisherCreditTotalAmountRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
        visible: false
    },
    PublisherAnnouncedTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'announcedCommission',
        visible: true
    },
    PublisherCreditTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'total',
        visible: true,
        isSortable: true
    },
    CreativeTypeConfirmed: {
        format: formatKeys.array,
        titleKey: 'type'
    },
    CreativeIdTitleConfirmed: {
        format: formatKeys.array,
        titleKey: 'title'
    }
};

const treeMetric = [
    [
        // {
        //     rowspan: 2,
        //     config: {
        //         key: 'GroupBy',
        //     }
        // },
        {
            config: {
                key: 'groups',
                metrics: ['GroupBy']
            }
        },
        {
            config: {
                key: 'traffic',
                metrics: ['Visits', 'Visitors']
            }
        },
        // {
        //     config: {
        //         key: 'customers',
        //         metrics: ['VisitorsPerSaleCountNew', 'VisitorsPerSaleCountRejected', 'VisitorsPerSaleCountConfirmed']
        //     }
        // },
        {
            config: {
                key: 'actions',
                metrics: ['ActionNameVerifiedCountConfirmed', 'ActionNameRegCountConfirmed']
            }
        },
        {
            config: {
                key: 'conversion',
                titleTemplate: '{{ title }} (CR)',
                metrics: ['ConversionRatioToRegConfirmed']
            }
        },
        {
            config: {
                key: 'regs',
                metrics: ['PublisherEarnPerClickAmountNew', 'PublisherEarnPerClickAmountRejected', 'PublisherEarnPerClickAmountConfirmed']
            }
        },
        {
            config: {
                key: 'sales',
                metrics: ['SaleSumNew', 'SaleSumRejected']
            }
        },
        {
            config: {
                key: 'deposit',
                metrics: ['FirstPaymentCountConfirmed', 'TotalPaymentCountConfirmed', 'FirstPaymentSumConfirmed', 'TotalPaymentSumConfirmed']
            }
        },
        {
            config: {
                key: 'commission',
                metrics: ['PublisherAnnouncedTotalAmountConfirmed', 'PublisherCreditTotalAmountConfirmed']
            }
        },
        {
            config: {
                key: 'creative',
                metrics: ['CreativeTypeConfirmed', 'CreativeIdTitleConfirmed']
            }
        }
    ],
    // [
    //     {
    //         config: {
    //             key: 'actionsLeads',
    //             parentKey: 'actions',
    //             titleKey: 'leads',
    //             metrics: ['ActionTypeLeadCountNew', 'ActionTypeLeadCountRejected', 'ActionTypeLeadCountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'actionsSales',
    //             parentKey: 'actions',
    //             titleKey: 'sales',
    //             metrics: ['ActionTypeSaleCountNew', 'ActionTypeSaleCountRejected', 'ActionTypeSaleCountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'conversionLead',
    //             parentKey: 'conversion',
    //             titleKey: 'lead',
    //             titleTemplate: '{{ title }} CR',
    //             metrics: ['ConversionRatioToLeadNew', 'ConversionRatioToLeadRejected', 'ConversionRatioToLeadConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'promotionCommission',
    //             parentKey: 'commission',
    //             metrics: ['PromotionTotalAmountNew', 'PromotionTotalAmountRejected', 'PromotionTotalAmountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'contractCommission',
    //             parentKey: 'commission',
    //             metrics: ['PublisherCommissionTotalAmountNew', 'PublisherCommissionTotalAmountRejected', 'PublisherCommissionTotalAmountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'commissionTotal',
    //             parentKey: 'commission',
    //             titleKey: 'total',
    //             metrics: ['PublisherCreditTotalAmountNew', 'PublisherCreditTotalAmountRejected', 'PublisherCreditTotalAmountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'FTDsCount',
    //             parentKey: 'deposit',
    //             metrics: ['FirstPaymentCountNew', 'FirstPaymentCountRejected', 'FirstPaymentCountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'totalCount',
    //             parentKey: 'deposit',
    //             metrics: ['TotalPaymentCountNew', 'TotalPaymentCountRejected', 'TotalPaymentCountConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'FTDsSum',
    //             parentKey: 'deposit',
    //             metrics: ['FirstPaymentSumNew', 'FirstPaymentSumRejected', 'FirstPaymentSumConfirmed']
    //         }
    //     },
    //     {
    //         config: {
    //             key: 'totalSum',
    //             parentKey: 'deposit',
    //             metrics: ['TotalPaymentSumNew', 'TotalPaymentSumRejected', 'TotalPaymentSumConfirmed']
    //         }
    //     }
    // ]
];

export {
    formatKeys,
    metrics,
    treeMetric
};
